import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { useAnalytics } from "../contexts/analytics/hooks";
import { useHospitalData } from "../contexts/HospitalDataProvider";
import { useSnackbar } from "../contexts/SnackbarContext";
import { backendService } from "../services/backend.service";

export const useSelfSchedulingPublish = () => {
	const { showSnackbar } = useSnackbar();
	const { chosenDepartment, showErrorSnackbar } = useHospitalData();
	const { track } = useAnalytics();
	const { t } = useTranslation();

	return useMutation({
		mutationFn: async (request: { preferences: Array<{ startDate: string; endDate: string }> }) => {
			track("self_scheduling_publish_start");
			const response = await backendService.publishSelfScheduling({ ...request, departmentId: chosenDepartment.department_id });
			return response.data;
		},
		onSuccess: () => {
			track("self_scheduling_publish_success");
			showSnackbar(t("preferences.published.successfully"), "success");
		},
		onError: (error) => showErrorSnackbar(t("failed.to.publish.preferences"), {}, error),
	});
};

export const useImportSelfScheduling = () => {
	const { chosenDepartment, showErrorSnackbar } = useHospitalData();
	const { track } = useAnalytics();
	const { t } = useTranslation();

	return useMutation({
		mutationFn: async () => {
			track("self_scheduling_import_start");
			return await backendService.importSelfScheduling(chosenDepartment.department_id);
		},
		onSuccess: () => {
			track("self_scheduling_import_success");
		},
		onError: (error) => {
			track("self_scheduling_import_error");
			showErrorSnackbar(t("failed.to.import.self.scheduling"), {}, error);
		},
	});
};

export const useCompleteSelfScheduling = () => {
	const { chosenDepartment, showErrorSnackbar } = useHospitalData();
	const { track } = useAnalytics();
	const { t } = useTranslation();

	return useMutation({
		mutationFn: async () => {
			track("self_scheduling_complete_start");
			return await backendService.completeSelfScheduling(chosenDepartment.department_id);
		},
		onSuccess: () => track("self_scheduling_complete_success"),
		onError: (error) => showErrorSnackbar(t("failed.to.complete.self.scheduling"), {}, error),
	});
};
